// extracted by mini-css-extract-plugin
module.exports = {"main":"MainPage_main__o8PoA"};